import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

const CommunityTextService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityText',
      method: 'get',
      request: (communityTag, language) => ({
        url: apiRoutes.communityText(communityTag, language),
      }),
    },
  ])(ComposedComponent);

export default CommunityTextService;
